export default __webpack_public_path__ + "static/media/jobseeker.7c78004b.svg";